import { identity, size } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';

import { getUser, getUserSuccess } from '../actions/user';
import { userSelector } from '../selectors';
import Header, { primitives } from './Header';
import { createReduxStore } from './store';
import { MetricsProvider } from '@zocdoc/frontend-metrics';

const enhancers = typeof window !== 'undefined' && window.devToolsExtension
    ? [window.devToolsExtension()]
    : [];

export const store = createReduxStore(enhancers);

const ConnectedHeader = connect(identity)(Header);

class HeaderContainer extends PureComponent {
    static propTypes = {
        /**
         * pass a predetermined user API response for testing purposes
         */
        user: PropTypes.object,

        store: PropTypes.object,
    };

    static defaultProps = {
        store,
    };

    componentDidMount() {
        if (this.props.user) {
            this.props.store.dispatch(getUserSuccess(this.props.user));
        } else {
            this.maybeGetUser();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('load', this.getUser);
    }

    render() {
        return (
            <ConnectedHeader {...this.props} />
        );
    }

    getUser = () => this.props.store.dispatch(getUser());

    maybeGetUser() {
        const state = this.props.store.getState();

        if (this.props.theme.allowSignIn && size(userSelector(state)) === 0) {
            if (document.readyState === 'complete') {
                this.getUser();
            } else window.addEventListener('load', this.getUser);
        }
    }
}

const HeaderWithMetrics = withTheme(HeaderContainer);

export default function (props) {
    return (
        <MetricsProvider sendMetric={() => {}}>
            <HeaderWithMetrics {...props} />
        </MetricsProvider>
    );
}

export { primitives, HeaderWithMetrics };
